import React from "react";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import { useRouter } from "../../context/RouterContext";
import { useStores } from "../../context/StoreContext";
import { getRestrictedTabs } from "../Settings";
import { IconButton } from "./IconButton";

export interface ISettingsButtonProps extends ITestableComponentProps {
    onClicked: () => void;
    children?: React.ReactNode;
}

export function SettingsButton(props: ISettingsButtonProps) {
    const { onClicked } = props;
    const { authStore } = useStores();
    const { routeTo } = useRouter();

    const restricted = !getRestrictedTabs().some(_ =>
        authStore.hasAccess(_.resource, _.requiredAccess),
    );

    // show settings if the user can actually edit any of the settings.
    if (restricted) {
        return null;
    }

    return (
        <IconButton
            icon="settings"
            to={routeTo.settings()}
            onClicked={onClicked}
            data-testid={props["data-testid"]}
        >
            Settings
        </IconButton>
    );
}
